const DS_TF = {
  '1s': '1', '1m': '1', '5m': '5', '15m': '15', '30m': '30',
  '1H': '60', '2H': '120', '4H': '240', '1D': 'D', '1W': 'W',
};

export default function TradingChart({ pairAddress, chainId = 'solana', timeframe = '1H' }) {
  const interval = DS_TF[timeframe] || '60';

  if (!pairAddress) {
    return (
      <div style={{
        width: '100%', height: '100%',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 10, color: '#2a3a4a', fontSize: 12,
      }}>
        <svg viewBox="0 0 40 40" fill="none" width="32" height="32">
          <circle cx="20" cy="20" r="16" stroke="#1e2530" strokeWidth="1.5"/>
          <path d="M14 20h12M20 14v12" stroke="#1e2530" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        Données de marché non disponibles pour ce token
      </div>
    );
  }

  const src =
    `https://dexscreener.com/${chainId}/${pairAddress}` +
    `?embed=1&loadChartSettings=0&trades=1&tabs=0&info=0` +
    `&chartLeftToolbar=1&chartTheme=dark&theme=dark` +
    `&chartStyle=1&chartType=usd&interval=${interval}`;

  return (
    <iframe
      key={src}
      src={src}
      style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
      title="DexScreener Chart"
      allow="clipboard-write"
    />
  );
}